import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-24 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
              About the Resource
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6 text-balance">
              What Is Vigorbuy Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
              <strong>Vigorbuy Spreadsheet</strong> is a structured product discovery resource that helps shoppers organize, compare, and explore products efficiently. Instead of searching across hundreds of scattered pages, users can access categorized product information, curated recommendations, buying tips, and comparison resources — all consolidated into one accessible and easy-to-navigate platform.
            </p>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mt-4">
              Whether you are browsing the latest <strong>vigorbuy spreadsheet 2026</strong> updates, hunting for hidden gems through <strong>vigorbuy finds</strong>, or referencing <strong>vigorbuy QC photos</strong> to verify product quality before ordering, this resource hub is designed to make your shopping research faster, clearer, and more organized.
            </p>
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-800 text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              Read Complete Beginner Guide <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex-shrink-0 w-full lg:w-[380px]">
            <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20product%20discovery%20concept%20illustration%20with%20organized%20fashion%20items%20floating%20on%20soft%20cream%20background%2C%20includes%20sneakers%20hoodies%20bags%20and%20accessories%20arranged%20in%20a%20harmonious%20grid%20pattern%2C%20modern%20minimalist%20art%20style%2C%20warm%20terracotta%20and%20sage%20green%20accents%2C%20clean%20organized%20aesthetic%2C%20no%20text%2C%20sophisticated%20shopping%20catalog%20visual&width=800&height=1000&seq=whatis-illustration-vigorbuy-12&orientation=portrait"
                alt="Vigorbuy Spreadsheet organized product discovery and shopping resource illustration"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}